import {
  AccountAdminApi,
  AccountOnboardingApi,
  AccountUserApi,
  Configuration,
  Middleware,
  ResponseContext,
} from '@quick/client';
import { env } from '../../configs/EnvironmentConfig';
import { auth } from '../../auth/firebaseAuth';
import store from '../../redux/store';
import { signOut } from '../../redux/actions';

const basePath = env.REACT_APP_API_ENDPOINT_URL;

const authorizationMiddleware: Middleware = {
  pre: async (context) => {
    const token = await auth.currentUser?.getIdToken();

    context.init.headers = {
      ...context.init.headers,
      'Firebase-auth': 'true',
      Authorization: 'Bearer ' + token,
    };

    return context;
  },
  post: async (context: ResponseContext) => {
    const response = context.response;
    if (response.status === 401) {
      await auth.signOut();
      store.dispatch(signOut());
    }
    return context.response;
  },
};

export const accountAdminApi = new AccountAdminApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const accountOnboardingApi = new AccountOnboardingApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);

export const accountUserApi = new AccountUserApi(
  new Configuration({
    basePath,
    middleware: [authorizationMiddleware],
  })
);
